import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as SetSimulatorTypes } from '../setSimulator/actions';
import { Types as TypesProfile } from '../../getProfile/actions';
import AdminSimulatorRepository from '../../../repositories/AdminSimulatorRepository';
import AdminSimulatorDataRepository from '../../../../data/repositories/AdminSimulatorDataRepository';
import AuthManager from '../../../../core/managers/authManager';
import ProfileRepository from '../../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../../data/repositories/ProfileDataRepository';
import { KeycloakManager } from '../../../../core/managers/keycloakManager';
import DateHelpers from '@/core/helpers/DateHelper';

export default function* execute(action: any): any {
  try {
    const { studentId } = action;
    yield put({ type: Types.GET_STUDENT_BY_ID_REQUEST });
    // 1. Buscar al estudiante
    const adminSimulatorRepository: AdminSimulatorRepository =
      new AdminSimulatorDataRepository();
    const adminSimulatorResponse = yield call(
      adminSimulatorRepository.getStudentInformationById,
      studentId
    );
    if (!adminSimulatorResponse) {
      yield put({
        type: Types.GET_STUDENT_BY_ID_FAILURE,
        error: 'error-01'
      });
      return;
    }
    const { studentCode, firstName, lastName } = adminSimulatorResponse;
    const { userId } = KeycloakManager.getInstance().getToken();
    // if (config.DATASOURCE_ENV === 'MOCK') yield delay(1500);

    // 3. setea el auth con el usuario simulado
    const credentials = AuthManager.getCredentials();
    AuthManager.setCredentials({
      token: credentials?.token || '',
      refreshToken: credentials?.refreshToken || '',
      userRole: credentials?.userRole || '',
      userId: credentials?.userId || '',
      userIdSimulated: studentCode
    });
    // 4. llamar a profile y profilePhoto del studiante simulado
    const profileRepository: ProfileRepository = new ProfileDataRepository();
    const profileResponse = yield call(profileRepository.getProfile);
    if (!profileResponse) {
      yield put({
        type: Types.GET_STUDENT_BY_ID_FAILURE,
        error: 'error-02'
      });
      return;
    }
    yield put({
      type: TypesProfile.GET_PROFILE_SUCCESS,
      data: profileResponse
    });
    const { career, plan, prog } = profileResponse.academic;
    const { id: period } = profileResponse.academic.period;

    yield put({
      type: 'GET_PROFILE_ACL',
      career,
      plan,
      prog,
      period: period.toString()
    });
    yield put({ type: 'GET_PERIODS' });
    // yield delay(3000);
    const firstDateOfWeek = DateHelpers.getFirstDayOfWeekFromTimestamp(
      new Date().getTime()
    );
    yield put({
      type: 'GET_SCHEDULE_ONLY',
      startDate: firstDateOfWeek.getTime()
    });
    yield put({ type: 'GET_STUDENT_PORTAL_SETTINGS' });
    yield put({ type: 'CLEAR_SURVEY' });
    yield put({ type: 'CLEAR_TUTORIAL' });
    yield put({ type: 'GET_BANNER_LIST' });
    yield put({ type: 'GET_PROFILE_PHOTO' });

    // 2. setea el isSimulator en true y setea los campos de simulacion
    yield put({
      type: SetSimulatorTypes.ACTIVE_SIMULATOR,
      user: userId,
      userSimulated: studentCode,
      firstNameUserSimulated: `${firstName} ${lastName}`
    });

    yield put({
      type: Types.GET_STUDENT_BY_ID_SUCCESS,
      data: adminSimulatorResponse
    });
  } catch (error: any) {
    yield put({
      type: Types.GET_STUDENT_BY_ID_FAILURE,
      error: 'Ocurrió un error al leer datos del estudiante.'
    });
    throw new Error(error.message);
  }
}
